export const AVAILABLE_TRANSLATION_LANGUAGES = Object.freeze([
  { key: 1, text: "IsiZulu", value: "zu" },
  { key: 2, text: "IsiXhosa", value: "xh" },
  { key: 3, text: "Afrikaans", value: "af" },
  { key: 4, text: "XiTsonga", value: "ts" },
  { key: 5, text: "Sesotho", value: "st" },
  { key: 6, text: "Sepedi", value: "nso" },
  { key: 7, text: "Portuguese (Portugal)", value: "pt" },
  { key: 8, text: "French (France)", value: "fr" }
]);

export const DEFAULT_TRANSLATION_LANGUAGE_CODES = Object.freeze(
  AVAILABLE_TRANSLATION_LANGUAGES.map(({ value }) => value)
);

const TRANSLATION_LANGUAGE_NAMES = Object.freeze({
  en: "English",
  ...AVAILABLE_TRANSLATION_LANGUAGES.reduce((names, { text, value }) => ({
    ...names,
    [value]: text
  }), {})
});

export const TRANSLATION_MODES = Object.freeze({
  ADDITIVE: "additive",
  RETRANSLATE: "retranslate",
  REPLACE: "replace"
});

export const getTranslationRequestLanguages = (item) => {
  const configuredLanguages = Array.isArray(item?.languages)
    ? item.languages
    : DEFAULT_TRANSLATION_LANGUAGE_CODES;

  return [...new Set(configuredLanguages)]
    .filter((languageCode) => languageCode !== "en")
    .map((languageCode) => ({
      code: languageCode,
      text: TRANSLATION_LANGUAGE_NAMES[languageCode] || languageCode
    }));
};

export const createTranslationRequest = (
  item,
  translationMode = TRANSLATION_MODES.ADDITIVE
) => {
  if (!Object.values(TRANSLATION_MODES).includes(translationMode)) {
    throw new Error(`Unsupported translation mode: ${translationMode}`);
  }

  return {
    ...item,
    languages: getTranslationRequestLanguages(item).map(({ code }) => code),
    translationMode
  };
};
